export default __webpack_public_path__ + "static/media/clock.5dfe4b09.svg";